/**
 * AI Chat discovery experiment (nav vs floating rail).
 */
export const AI_APP_PATH = '/app/ai'

/** Embedded AI disclaimer “Learn more” — swap for the final Help Center article when ready. */
export const AI_EMBEDDED_DISCLAIMER_LEARN_MORE_URL = 'https://help.calendly.com/hc/en-us/articles/36763109075735-AI-at-Calendly'

export const AI_CHAT_DISCOVERY_EXPERIMENT_KEY = 'ai_assistant_entry_point_experience'

export const AI_CHAT_DISCOVERY_VARIANT = {
  CONTROL: 'control',
  LEFT_LOGO: 'left_logo_test_a',
  LEFT_BUTTON: 'left_button_test_b',
  LOGO_ONLY: 'logo_test_c',
  BUTTON_ONLY: 'button_test_d',
  TOP_BUTTON: 'button_test_top'
}

/** Two FAB shapes only: round icon for later vs text label. */
export const AI_CHAT_DISCOVERY_FAB_APPEARANCE = {
  ICON: 'icon',
  STRING: 'string',
}

export const AI_CHAT_DISCOVERY_NAVIGATION_LOCATION = {
  TOP_RIGHT: 'ask_ai_top_right',
  BOTTOM_RIGHT_FAB: 'ask_ai_bottom_right',
}

export const AI_CHAT_DISCOVERY_SPOTLIGHT_KEY = {
  TOP_RIGHT: 'ai_chat_discovery_top_button_spotlight_dismissed',
  BOTTOM_RIGHT_FAB: 'ai_chat_discovery_fab_spotlight_dismissed',
}

export const AI_CHAT_DISCOVERY_SPOTLIGHT_FLOW_ID = {
  TOP_RIGHT: 'ai_chat_discovery_top_right_spotlight',
  BOTTOM_RIGHT_FAB: 'ai_chat_discovery_fab_spotlight',
}

/** URL query param (`=1`) to force-show discovery entry spotlight regardless of dismiss state. */
export const AI_CHAT_DISCOVERY_SPOTLIGHT_FORCE_SHOW_PARAM = 'show_ai_chat_discovery_spotlight'
